/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Leistungsbescheidberlinpassgueltigbis4Inputs */

const de__field_leistungsbescheidberlinpassgueltigbis4 = /** @type {(inputs: _Field_Leistungsbescheidberlinpassgueltigbis4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsbescheid gültig bis`)
};

/**

* @param {_Field_Leistungsbescheidberlinpassgueltigbis4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_leistungsbescheidberlinpassgueltigbis4 = /** @type {((inputs?: _Field_Leistungsbescheidberlinpassgueltigbis4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Leistungsbescheidberlinpassgueltigbis4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_leistungsbescheidberlinpassgueltigbis4(inputs)
});
export { _field_leistungsbescheidberlinpassgueltigbis4 as "_field_leistungsbescheidBerlinPassGueltigBis" }